import type {
  HeaderNavigation,
  MobileMenuNavigation,
  MobileMenuNavItem,
} from "./types";
import { IntercomLogoIcon } from "./icons/intercom-logo-icon";
import {
  Icon1,
  Icon2,
  Icon3,
  Icon4,
  Icon6,
  Icon7,
  PersonIcon,
} from "./menu-icons";

export const baseFixtureData: HeaderNavigation = {
  logo: {
    icon: <IntercomLogoIcon />,
    href: "https://www.intercom.com",
    label: "Intercom",
  },
  primary: [
    {
      type: "dropdown",
      label: "Fin AI Agent",
      links: [
        [
          {
            title: "About Fin",
            links: [
              {
                href: "https://fin.ai/capabilities",
                analyticsId: "link_storybook_nav_about_fin_capabilities",
                title: "How Fin works",
                description:
                  "Fin resolves the most complex queries across any industry",
                icon: <Icon1 />,
              },
              {
                href: "https://fin.ai/channels",
                analyticsId: "link_storybook_nav_about_fin_channels",
                title: "Deploy in every channel",
                description: "Voice, email, chat, Slack, social and more",
                icon: <Icon2 />,
              },
              {
                href: "https://fin.ai/integrations",
                analyticsId: "link_storybook_nav_about_fin_integrations",
                title: "Integrate with your stack",
                description: "Fin works with any Helpdesk and every tool",
                icon: <Icon3 />,
              },
              {
                href: "https://fin.ai/trust-reliability",
                analyticsId: "link_storybook_nav_about_fin_trust_reliability",
                title: "Enterprise-grade security",
                description:
                  "Built for security, reliability, and transparency",
                icon: <Icon4 />,
              },
            ],
          },
        ],
        [
          {
            title: "Featured Capabilities",
            links: [
              {
                href: "https://fin.ai/procedures",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_procedures",
                title: "Procedures",
              },
              {
                href: "https://fin.ai/voice",
                analyticsId: "link_storybook_nav_featured_capabilities_voice",
                title: "Voice",
              },
              {
                href: "https://fin.ai/insights",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_insights",
                title: "Insights",
              },
              {
                href: "https://fin.ai/testing",
                analyticsId: "link_storybook_nav_featured_capabilities_testing",
                title: "Simulations",
              },
            ],
          },
          {
            title: "More about Fin",
            links: [
              {
                href: "https://fin.ai/ai-engine",
                analyticsId: "link_storybook_nav_more_about_fin_ai_engine",
                title: "AI technology",
              },
              {
                href: "https://fin.ai/updates",
                analyticsId: "link_storybook_nav_more_about_fin_updates",
                title: "Product updates",
              },
            ],
          },
        ],
        [
          {
            title: "Works across any industry",
            links: [
              {
                href: "https://fin.ai/solutions/financial-services",
                analyticsId:
                  "link_storybook_nav_works_across_any_industry_solutions_financial_services",
                title: "Financial services",
              },
              {
                href: "https://fin.ai/solutions/ecommerce",
                analyticsId:
                  "link_storybook_nav_works_across_any_industry_solutions_ecommerce",
                title: "Retail & ecommerce",
              },
              {
                href: "https://fin.ai/solutions/gaming",
                analyticsId:
                  "link_storybook_nav_works_across_any_industry_solutions_gaming",
                title: "Gaming",
              },
              {
                href: "https://fin.ai/solutions/technology",
                analyticsId:
                  "link_storybook_nav_works_across_any_industry_solutions_technology",
                title: "Software & tech",
              },
              {
                href: "https://fin.ai/solutions/enterprise",
                analyticsId:
                  "link_storybook_nav_works_across_any_industry_solutions_enterprise",
                title: "Enterprise",
              },
            ],
          },
        ],
      ],
    },
    {
      type: "dropdown",
      label: "Helpdesk",
      links: [
        [
          {
            title: "About Helpdesk",
            links: [
              {
                href: "https://www.intercom.com/helpdesk/capabilities",
                analyticsId:
                  "link_storybook_nav_about_helpdesk_helpdesk_capabilities",
                title: "How Helpdesk works",
                description: "A modern, AI-native Helpdesk",
                icon: <Icon7 />,
              },
              {
                href: "https://www.intercom.com/helpdesk/omnichannel",
                analyticsId:
                  "link_storybook_nav_about_helpdesk_helpdesk_omnichannel",
                title: "Works with all channels",
                description: "Phone, email, and live chat",
                icon: <Icon2 />,
              },
              {
                href: "https://www.intercom.com/app-store",
                analyticsId: "link_storybook_nav_about_helpdesk_app_store",
                title: "Integrates with your apps",
                description: "450+ apps to retain customers",
                icon: <Icon3 />,
                external: true,
              },
            ],
          },
        ],
        [
          {
            title: "Featured Capabilities",
            links: [
              {
                href: "https://www.intercom.com/helpdesk/inbox",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_inbox",
                title: "Inbox",
              },
              {
                href: "https://www.intercom.com/helpdesk/tickets",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_tickets",
                title: "Tickets",
              },
              {
                href: "https://www.intercom.com/helpdesk/help-center",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_help_center",
                title: "Help Center",
              },
              {
                href: "https://www.intercom.com/helpdesk/reporting",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_reporting",
                title: "Reporting",
              },
              {
                href: "https://www.intercom.com/helpdesk/outbound",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_outbound",
                title: "Outbound",
              },
              {
                href: "https://www.intercom.com/helpdesk/knowledge-hub",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_knowledge_hub",
                title: "Knowledge Hub",
              },
              {
                href: "https://www.intercom.com/helpdesk/copilot",
                analyticsId:
                  "link_storybook_nav_featured_capabilities_helpdesk_copilot",
                title: "Copilot",
              },
            ],
          },
        ],
        [
          {
            title: "More about Helpdesk",
            links: [
              {
                href: "https://www.intercom.com/early-stage",
                analyticsId:
                  "link_storybook_nav_more_about_helpdesk_early_stage",
                title: "Early stage program",
              },
              {
                href: "https://www.intercom.com/changes/en",
                analyticsId:
                  "link_storybook_nav_more_about_helpdesk_changes_en",
                title: "Product updates",
                external: true,
              },
            ],
          },
        ],
      ],
    },
    {
      type: "dropdown",
      label: "Customers",
      dropdownAlign: "center",
      dropdownClassName: "w-auto",
      links: [
        [
          {
            links: [
              {
                href: "https://fin.ai/customers",
                analyticsId: "link_storybook_nav_customers_fin_customers",
                title: "Fin customers",
                description: "Success stories about our AI Agent",
                icon: <Icon6 />,
              },
              {
                href: "https://www.intercom.com/customers",
                analyticsId:
                  "link_storybook_nav_customers_fin_helpdesk_customers",
                title: "Fin & Helpdesk customers",
                description: "Success stories about our complete solution",
                icon: <Icon7 />,
              },
            ],
          },
        ],
      ],
    },
    {
      type: "dropdown",
      label: "Resources",
      links: [
        [
          {
            title: "Learn",
            links: [
              {
                href: "https://events.intercom.com/",
                analyticsId: "link_storybook_nav_learn_events_intercom",
                title: "Webinars & events",
                description: "Demos and upcoming events",
                external: true,
                image: <img src="/image.webp" alt="Webinars & events" />,
              },
              {
                href: "https://academy.intercom.com/",
                analyticsId: "link_storybook_nav_learn_academy_intercom",
                title: "Intercom academy",
                description: "Master AI-first customer support",
                external: true,
              },
              {
                href: "https://academy.fin.ai/",
                analyticsId: "link_storybook_nav_learn_academy_fin_ai",
                title: "Fin academy",
                description: "Go deeper with Fin ",
                external: true,
              },
            ],
          },
        ],
        [
          {
            title: "Blogs",
            links: [
              {
                href: "https://fin.ai/research/",
                analyticsId: "link_storybook_nav_blogs_research",
                title: "AI research",
                external: true,
              },
              {
                href: "https://ideas.fin.ai",
                analyticsId: "link_storybook_nav_blogs_ideas_fin_ai",
                title: "AI ideas",
                external: true,
              },
              {
                href: "https://www.intercom.com/blog/",
                analyticsId: "link_storybook_nav_blogs_blog",
                title: "Intercom",
                external: true,
              },
            ],
          },
        ],
        [
          {
            title: "Support",
            links: [
              {
                href: "https://www.intercom.com/help/en",
                analyticsId:
                  "link_storybook_nav_support_help_en_intercom_help_center",
                title: "Intercom help center",
                external: true,
              },
              {
                href: "https://fin.ai/help/en",
                analyticsId:
                  "link_storybook_nav_support_help_en_fin_help_center",
                title: "Fin help center",
                external: true,
              },
              {
                href: "https://developers.intercom.com/",
                analyticsId: "link_storybook_nav_support_developers_intercom",
                title: "Developer hub",
                external: true,
              },
              {
                href: "https://fin.ai/professional-services",
                analyticsId: "link_storybook_nav_support_professional_services",
                title: "Professional services",
              },
            ],
          },
        ],
      ],
    },
  ],
  secondary: [
    {
      type: "iconButton",
      label: "Sign in",
      analyticsId: "link_storybook_nav_sign_in",
      href: "https://app.intercom.com/admins/sign_in",
      icon: <PersonIcon />,
    },
    {
      type: "link",
      label: "Contact sales",
      analyticsId: "link_storybook_nav_contact_sales",
      href: "https://www.intercom.com/contact-sales",
    },
    {
      type: "link",
      label: "View demo",
      analyticsId: "link_storybook_nav_view_demos",
      href: "https://www.intercom.com/view-demos",
    },
    {
      type: "button",
      label: "Start free trial",
      analyticsId: "btn_storybook_nav_signup",
      href: "https://www.intercom.com/signup",
    },
  ],
  crossSiteLink: {
    type: "button",
    label: "Fin AI Agent",
    analyticsId: "btn_storybook_nav_cross_site_fin_ai",
    variant: "secondary",
    isExternal: true,
    href: "https://fin.ai/",
    tooltip:
      "Our AI Agent and AI architecture trained specifically for customer service.",
  },
  // Comment this banner object out to disable it
  banner: {
    text: "Download the newly released 2026 Customer Service Transformation Report.",
    href: "https://www.intercom.com/customer-transformation-report?utm_source=homepage&utm_medium=display&utm_campaign=20260128-report-owned-2026cstransformationreport&utm_content=websitebanner",
    linkLabel: "Learn more",
    target: "_blank",
  },
};

export const baseMobileMenuData: MobileMenuNavigation = {
  primary: [...baseFixtureData.primary] as MobileMenuNavItem[],
  secondary: [
    {
      type: "smallLink",
      label: "Sign in",
      analyticsId: "link_storybook_nav_mobile_sign_in",
      href: "https://app.intercom.com/admins/sign_in",
    },
    {
      type: "smallLink",
      label: "Contact sales",
      analyticsId: "link_storybook_nav_mobile_contact_sales",
      href: "https://www.intercom.com/contact-sales",
    },
  ],
  tertiary: [
    {
      type: "button",
      variant: "secondary",
      label: "View demo",
      analyticsId: "btn_storybook_nav_mobile_view_demos",
      href: "https://www.intercom.com/view-demos",
    },
    {
      type: "button",
      variant: "primary",
      label: "Start free trial",
      analyticsId: "btn_storybook_nav_mobile_start_free_trial",
      href: "https://www.intercom.com/view-demos",
    },
  ],
  crossSiteLink: {
    label: "Fin",
    href: "https://fin.ai/",
  },
};
